import { useMutation, useQueryClient } from "@tanstack/react-query";

import { exploreImagesQueryKey } from "@/hooks/queries/useGetExploreImages";
import { guacHttpClient } from "@/lib/http";
import {
  ExploreImage,
  ExploreImageFocus,
  ExploreImageIndustry,
  HttpResponse,
  PositionCategory,
} from "@/types";

export function useUpdateExploreImage() {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async ({
      id,
      positionCategories,
      focus,
      caption,
      keywords,
      industries,
    }: {
      id: string;
      positionCategories?: PositionCategory[];
      focus?: ExploreImageFocus;
      // An empty string clears the caption.
      caption?: string;
      // Each replaces the whole list; an empty array clears it.
      keywords?: string[];
      industries?: ExploreImageIndustry[];
    }) => {
      const res = await guacHttpClient.patch<
        ExploreImage,
        HttpResponse<ExploreImage>
      >(`explore-images/${id}`, {
        positionCategories,
        focus,
        caption,
        keywords,
        industries,
      });

      return res.data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: exploreImagesQueryKey });
    },
  });

  return mutation;
}
